import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StiiraError } from '@core/models';
import { NewEmployerPost } from '@core/models/leave-admin/employers/new-employer-post.model';
import { ErrorService, LayoutService } from '@core/services';
import { ManageEmployersService } from '@core/services/manage-employers.service';
import { position, onDragEnded } from '@shared/helpers/dialog-drag-constraints';
import { indicate, keepDialogOpen } from '@shared/helpers';
import { Observable, Subject } from 'rxjs';

@Component({
    selector: 'app-add-new-employer',
    templateUrl: './add-new-employer.component.html',
    styleUrls: ['./add-new-employer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddNewEmployerComponent implements OnInit {
  static readonly componentName = 'AddNewEmployerComponent';
  
  public form: UntypedFormGroup;

  public position = position;
  public onDragEnded = onDragEnded;

  isSubmitting$: Subject<boolean>;
  public isMobile$: Observable<boolean>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { sysText: any },
    private service: ManageEmployersService,
    private errorService: ErrorService,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AddNewEmployerComponent>,
    private layoutService: LayoutService
  ) {
    this.isSubmitting$ = new Subject();
    this.form = this.fb.group({
      companyName: [null, Validators.required]
    });
  }

  ngOnInit(): void {
    this.isMobile$ = this.layoutService.isMobile$();
  }

  onSubmit() {
    let newEmployerPost: NewEmployerPost = {
      companyName: this.form.controls.companyName.value
    }
    this.service
      .postNewEmployer(newEmployerPost)
      .pipe(
        indicate(this.isSubmitting$),
        keepDialogOpen(this.dialogRef)
      )
      .subscribe((res) => {
        this.dialogRef.close(res);
      }, (err: StiiraError) => this.errorService.setFormModelStateErrors(this.form, err.modelStateErrors));
  }
}